import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ErrorBoundary, AuthProvider, HcaptchaProvider, runtimeConfig, ProtectedRoute } from '@footsteps/shared';
import { Home, Intake, Summary, Submitted } from './pages';
import theme from './theme';
import { routes } from './routes';
import { WozCaseManagerProvider } from './components/woz-case-manager/woz-case-manager.provider';

function App() {
  const hcaptchaSiteKey = runtimeConfig.VITE_HCAPTCHA_SITE_KEY ?? '';
  const hcaptchaDisabled = runtimeConfig.VITE_HCAPTCHA_DISABLED === 'true';

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <AuthProvider>
          <HcaptchaProvider siteKey={hcaptchaSiteKey} isDisabled={hcaptchaDisabled}>
            <WozCaseManagerProvider>
              <BrowserRouter>
                <Routes>
                  <Route path={routes.home} element={<Home />} />
                  <Route path={routes.intake} element={<ProtectedRoute element={<Intake />} />} />
                  <Route path={routes.summary} element={<ProtectedRoute element={<Summary />} />} />
                  <Route path={routes.submitted} element={<ProtectedRoute element={<Submitted />} />} />
                </Routes>
              </BrowserRouter>
            </WozCaseManagerProvider>
          </HcaptchaProvider>
        </AuthProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
